<template>
    <section class="analysis-results main-section">
        <div class="show-on-fixed pane-fixed">
            <div class="card brder-radius-x pd-2">
                <div class="card-body brder-radius-x">
                    <h1 class="p-title">
                        <a href="javascript:;" class="text-primary" @click="$router.go(-1)">
                            Salle de prélèvement
                        </a> | <span> {{ modele_analyse.analyse.nom }} | </span> Saisie résultats
                    </h1>

                    <div class="flx flx__wrap flx-start flx__gap--02 mt-3">
                        <div class="">
                            <span class="font-wgh-600">Nom et Prénoms : </span>
                            <span>
                                {{ this.patientMeta.patient_fullname }}
                            </span>
                        </div>

                        <div class="">
                            <span class="font-wgh-600">Age : </span> <span>{{ this.patientMeta.patient_age }}</span>&nbsp;&nbsp;
                            <span class="font-wgh-600">&nbsp;&nbsp;Sexe : </span> <span>{{ capitalizeFirstLetter(this.patientMeta.patient_gender) }}</span>&nbsp;&nbsp;
                            <span class="font-wgh-600">&nbsp;&nbsp;Téléphone : </span>{{ this.patientMeta.patient_phone }}
                        </div> 
                    </div>
                    <div class="flx flx__wrap flx-start flx__gap--02 mt-2">
                        <div class="">
                            <span class="font-wgh-600">Médecin demandeur : </span> {{  patientMeta.doctor_fullname  }}
                        </div>

                        <div class="">
                            <span class="font-wgh-600">Renseignement clinique : </span> {{ patientMeta.clinical_inquiries }}&nbsp;&nbsp;
                        </div> 
                    </div>

                    <div class="flx flx__wrap flx-start flx__gap--02 mt-2">
                        <div class="">
                            <span class="font-wgh-600">Technique utilisée : </span> {{  patientMeta.methodology_applied  }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card section-body top-290 scroll-bar brder-radius-x">
            <div class="card-body">
                <div class="row my-2 mt-2">
                    <div class="col-12 pdlr-x">
                        <div class="card h-100 animate animate-fadeIn">
                            <div class="card-body">
                                <ResultatsAnalysesFormTable 
                                    @emitSetResult="printResultSaved"
                                />
                            </div>                
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row mb-4">
            <div class="col-lg-12">
                <div class="body-header">
                    <h1 class="p-title">
                        <a href="javascript:;" class="text-primary" @click="$router.go(-1)">
                            Salle de prélèvement
                        </a> | <span> {{ modele_analyse.analyse.nom }} | </span> Saisie résultats
                    </h1>
                </div>
            </div>
        </div> -->

        <!-- <div class="row mb-2">
            <div class="col-lg-12">
                <CollapseCard>
                    <template v-slot:header>Entête du tableau des résultats</template>
                    <template v-slot:body>
                        <table class="patient-details w-100 table table-bordered mb-2">
                            <tbody>
                                <tr v-for="(row, index) in head_meta_rows" :key="index">
                                    <td :colspan="row?.colspan" :class="'text-' + row?.align">
                                        <strong>{{ row?.title }}</strong>
                                        <span class="">{{ row?.value }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </CollapseCard>
            </div>
        </div> -->

        

        <!-- Print  -->
        <div 
            class="card w-100 print-anl" 
            slot="pdf-content" 
            v-if="can_print"
        >
            <div class="card-body pdlr-x">
                <EnteteBonEtFacture />
                <ResultatPatient
                    :results="results"
                    :view_result_loading="view_result_loading"
                />
            </div>
        </div>
    </section>
</template>

<script>

// import CollapseCard from '@/components/cards/CollapseCard.vue';
import ResultatsAnalysesFormTable from './components/ResultatsAnalysesFormTable.vue';
import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient'
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

export default {
    name: 'SaisieResultats',
    components: {
        EnteteBonEtFacture,
        ResultatsAnalysesFormTable, ResultatPatient
    },
    data() {
        return {
            view_result_loading: false,
            results: null,
            can_print: false,
            head_info: {}
        }
    },
    computed: {
        patientMeta() {
            return this.$store.getters["patientMetaData"];
        },

        head_meta_rows() {
            const rows = [
                {
                    title: "Nom & prénom(s) : ",
                    value: this.patientMeta.patient_fullname ?? '-',
                    colspan: 2,
                    align: 'left',
                },
                {
                    title: "Sexe : ",
                    value: this.patientMeta.patient_gender ?? '-',
                },
                {
                    title: "Age : ",
                    value: this.patientMeta.patient_age ?? '-',
                    align: 'left',
                },
                {
                    title: "Médecin demandeur : ",
                    value: this.patientMeta.doctor_fullname ?? '-',
                    colspan: 2,
                    align: 'left',
                },
                {
                    title: "Renseignement clinique : ",
                    value: this.patientMeta.clinical_inquiries ?? '-',
                    colspan: 2,
                },
                {
                    title: "Technique utilisée : ",
                    value: this.patientMeta.methodology_applied ?? '-',
                    colspan: 2,
                }
            ];

            return rows;
        },

        modele_analyse() {
            return this.$store.getters.current_modele_analyse
        },
    },

    watch: {
        
    },

    mounted() {
    },

    methods: {
        printResultSaved(results) {
            console.log("saved results :",results);
            
            this.results = results
            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
        }
    },
}
</script>

<style src="./styles/resultats-analyse.scss" lang="scss" scoped></style>